import styled from 'styled-components'
// static
import MaterialTrashIcon from '@mui/icons-material/Delete'
// themes
import { colors } from 'themes'
import { darken } from 'polished'

const TrashIcon = styled(MaterialTrashIcon)`
  & {
    color: ${colors.gray300};

    &:hover {
      cursor: pointer;
      color: ${darken(0.1, colors.gray300)};
    }
  }
`

export default TrashIcon
